"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultResultsStatuses = exports.MIN_PAGE_SIZE = exports.DATE_FORMAT = void 0;
exports.DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
exports.MIN_PAGE_SIZE = 20;
exports.defaultResultsStatuses = [
    'TRADING',
    'SUSPENDED',
    'OPEN',
    'CANCELLED',
    'INTERRUPTED',
    'POSTPONED',
    'ENDED',
    'CLOSED',
];
//# sourceMappingURL=constants.js.map